var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContactForm = function SvgContactForm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 96 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M346 787h268v-22H346v22Zm0-163h268v-22H346v22Zm-80 300q-22.775 0-38.387-15.612Q212 892.775 212 870V282q0-22.775 15.613-38.388Q243.225 228 266 228h326l156 156v486q0 22.775-15.612 38.388Q716.775 924 694 924H266Zm315-530V250H266q-12 0-22 10t-10 22v588q0 12 10 22t22 10h428q12 0 22-10t10-22V394H581ZM234 250v144-144 652-652Z"
  })));
};
export default SvgContactForm;